import { TextInputProps } from './TextInput.native'

//@ts-ignore
import _TextInput from './TextInput'

export * from './TextInput.native'

const TextInput = _TextInput as React.FC<
  TextInputProps & { ref?: React.Ref<any> }
>

export default TextInput
